import { z } from "zod";
import shortid from "shortid";
import { TopolTextBlockSchema } from "../blocks/textBlockSchema";
import { TopolButtonBlockSchema } from "../blocks/buttonBlockSchema";
import { TopolDividerBlockSchema } from "../blocks/dividerBlockSchema";
import { TopolGifBlockSchema } from "../blocks/gifBlockSchema";
import { TopolSpacerBlockSchema } from "../blocks/spacerBlockSchema";
import { TopolImageAndVideoBlockSchema } from "../blocks/imageAndVideoBlockSchema";
import { TopolSocialBlockSchema } from "../blocks/socialBlockSchema";
import { TopolRawBlockSchema } from "../blocks/rawBlockSchema";
import { TopolProductBlockSchema } from "../blocks/productBlockSchema";
import { TopolFeedBlocksSchemas } from "../blocks/feedBlockSchema";
import { TopolArticleBlockSchema } from "../blocks/articleBlockSchema";
import { TopolCarouslBlockSchema } from "../blocks/carouselBlockSchema";
import { TopolDynamicBlockSchema } from "../blocks/dynamicBlockSchema";
import { TopolLoopBlockSchema } from "../blocks/loopBlockSchema";
import { TopolRatingBlockSchema } from "../blocks/ratingBlockSchema";
import {
  TopolVertcalAlignSchema,
  TopolColorSchema,
  TopolColorBearingSchema,
} from "../commonSchema";

export * from "../blocks/textBlockSchema";
export * from "../blocks/buttonBlockSchema";
export * from "../blocks/dividerBlockSchema";
export * from "../blocks/gifBlockSchema";
export * from "../blocks/spacerBlockSchema";
export * from "../blocks/imageAndVideoBlockSchema";
export * from "../blocks/socialBlockSchema";
export * from "../blocks/rawBlockSchema";
export * from "../blocks/productBlockSchema";
export * from "../blocks/feedBlockSchema";
export * from "../blocks/articleBlockSchema";
export * from "../blocks/carouselBlockSchema";
export * from "../blocks/dynamicBlockSchema";
export * from "../blocks/loopBlockSchema";
export * from "../blocks/ratingBlockSchema";

const topolBlockDiscriminatedUnion = z.discriminatedUnion("tagName", [
  TopolTextBlockSchema,
  TopolButtonBlockSchema,
  TopolGifBlockSchema,
  TopolDividerBlockSchema,
  TopolSpacerBlockSchema,
  TopolImageAndVideoBlockSchema,
  TopolSocialBlockSchema,
  TopolRawBlockSchema,
  TopolProductBlockSchema,
  TopolDynamicBlockSchema,
  TopolArticleBlockSchema,
  TopolCarouslBlockSchema,
  TopolFeedBlocksSchemas,
  TopolLoopBlockSchema,
  TopolRatingBlockSchema,
]);

export type TopolBlock = z.infer<typeof topolBlockDiscriminatedUnion>;

export const TopolColumnStyleAttributesSchema = z.object({
  "vertical-align": TopolVertcalAlignSchema.catch("top"),
  "border-right": z.string().optional().catch(undefined),
  "border-top": z.string().optional().catch(undefined),
  "border-left": z.string().optional().catch(undefined),
  "border-bottom": z.string().optional().catch(undefined),
  "background-color": TopolColorSchema.optional().catch(undefined),
  "border-radius": z.string().optional().catch(undefined),
  border: z.string().optional().catch(undefined),
  padding: z.string().optional().catch(undefined),
  "inner-attributes": z.boolean().optional().catch(undefined),
  "column-gradient": TopolColorBearingSchema.optional().catch(undefined),
});

export const TopolColumnSchema = z.object({
  tagName: z.literal("mj-column"),
  attributes: z
    .object({
      width: z.string().catch("100%"),
      ...TopolColumnStyleAttributesSchema.shape,
      "css-class": z.string().nullable().optional().catch(undefined),
    })
    .default({
      width: "100%",
      "vertical-align": "top",
    }),
  children: topolBlockDiscriminatedUnion.array().default([]),
  uid: z.string().catch(() => shortid.generate()),
});

export type TopolColumn = z.infer<typeof TopolColumnSchema>;
